var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortArrowDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29109 10.7447L8.66666 10.7447L11.6667 14.6666L14.6667 10.7447L13.6667 10.7447L12.6667 10.7447L12.6667 3.99996L10.6667 3.99996L10.6667 10.7447L9.29109 10.7447Z",
    fill: "#B2BFD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37557 5.25523L8 5.25523L5 1.33331L2 5.25523L3 5.25523L3.99999 5.25523L3.99999 12L6 12L6 5.25523L7.37557 5.25523Z",
    fill: "#B2BFD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowDefault);
export default __webpack_public_path__ + "static/media/SortArrowDefault.c9c146ec.svg";
export { ForwardRef as ReactComponent };